import * as types from "./mutation-types";

export const setGlobalLoading = ({ commit }, globalLoading_payload) => {
    commit(types.SET_GLOBALLOADING, globalLoading_payload);
};

export const setEquipmentCraft = ({ commit }, equipmentcraft_payload) => {
    commit(types.SET_EQUIPMENT_CRAFT, equipmentcraft_payload);
};

export const setEquipmentData = ({ commit }, equipmentdata_payload) => {
    commit(types.SET_EQUIPMENT_DATA, equipmentdata_payload);
};

export const setEquipmentEnhanceRate = ({ commit }, equipmentEnhanceRate_payload) => {
    commit(types.SET_EQUIPMENT_ENHANCE_RATE_DATA, equipmentEnhanceRate_payload);
};

export const setQuestData = ({ commit }, questData_payload) => {
    commit(types.SET_QUEST_DATA, questData_payload);
};

export const setQuestRewardData = ({ commit }, questRewardData_payload) => {
    commit(types.SET_QUEST_REWARD_DATA, questRewardData_payload);
};

export const setWaveGroupData = ({ commit }, waveGroupData_payload) => {
    commit(types.SET_WAVE_GROUP_DATA, waveGroupData_payload);
};

export const setEnemyRewardData = ({ commit }, enemyRewardData_payload) => {
    commit(types.SET_ENEMY_REWARD_DATA, enemyRewardData_payload);
};

export const setUnitData = ({ commit }, unitData_payload) => {
    commit(types.SET_UNIT_DATA, unitData_payload);
};

export const setActualUnitBackground = ({ commit }, actualUnitBackground_payload) => {
    commit(types.SET_ACTUAL_UNIT_BACKGROUND, actualUnitBackground_payload);
};

export const setQuestAreaData = ({ commit }, questAreaData_payload) => {
    commit(types.SET_QUEST_AREA_DATA, questAreaData_payload);
};

export const setUnitProfile = ({ commit }, unitProfile_payload) => {
    commit(types.SET_UNIT_PROFILE, unitProfile_payload);
};

export const setUnitPromotion = ({ commit }, unitPromotion_payload) => {
    commit(types.SET_UNIT_PROMOTION, unitPromotion_payload);
};

export const setUnitSkillData = ({ commit }, unitSkillData_payload) => {
    commit(types.SET_UNIT_SKILL_DATA, unitSkillData_payload);
};

export const setUnitAttackPattern = ({ commit }, unitAttackPattern_payload) => {
    commit(types.SET_UNIT_ATTACK_PATTERN, unitAttackPattern_payload);
};

export const setSkillData = ({ commit }, skillData_payload) => {
    commit(types.SET_SKILL_DATA, skillData_payload);
};

export const setExperienceUnit = ({ commit }, experienceUnit_payload) => {
    commit(types.SET_EXPERIENCE_UNIT, experienceUnit_payload);
};

export const setExperienceTeam = ({ commit }, experienceTeam_payload) => {
    commit(types.SET_EXPERIENCE_TEAM, experienceTeam_payload);
};

export const setGrandArenaDailyRankReward = ({ commit }, grandArenaDailyRankReward_payload) => {
    commit(types.SET_GRAND_ARENA_DAILY_RANK_REWARD, grandArenaDailyRankReward_payload);
};

export const setGrandArenaDefenceReward = ({ commit }, grandArenaDefenceReward_payload) => {
    commit(types.SET_GRAND_ARENA_DEFENCE_REWARD, grandArenaDefenceReward_payload);
};

export const setGrandArenaMaxRankReward = ({ commit }, grandArenaMaxRankReward_payload) => {
    commit(types.SET_GRAND_ARENA_MAX_RANK_REWARD, grandArenaMaxRankReward_payload);
};

export const setGrandArenaTimeRankReward = ({ commit }, grandArenaTimeRankReward_payload) => {
    commit(types.SET_GRAND_ARENA_TIME_RANK_REWARD, grandArenaTimeRankReward_payload);
};

export const setArenaDailyRankReward = ({ commit }, arenaDailyRankReward_payload) => {
    commit(types.SET_ARENA_DAILY_RANK_REWARD, arenaDailyRankReward_payload);
};

export const setArenaDefenceReward = ({ commit }, arenaDefenceReward_payload) => {
    commit(types.SET_ARENA_DEFENCE_REWARD, arenaDefenceReward_payload);
};

export const setArenaMaxRankReward = ({ commit }, arenaMaxRankReward_payload) => {
    commit(types.SET_ARENA_MAX_RANK_REWARD, arenaMaxRankReward_payload);
};

export const setArenaTimeRankReward = ({ commit }, arenaTimeRankReward_payload) => {
    commit(types.SET_ARENA_TIME_RANK_REWARD, arenaTimeRankReward_payload);
};

export const setCharaIdentity = ({ commit }, charaIdentity_payload) => {
    commit(types.SET_CHARA_IDENTITY, charaIdentity_payload);
};

export const setSkillCost = ({ commit }, skillCost_payload) => {
    commit(types.SET_SKILL_COST, skillCost_payload);
};

export const setEnemyParameter = ({ commit }, enemyParameter_payload) => {
    commit(types.SET_ENEMY_PARAMETER, enemyParameter_payload);
};

export const setSkillAction = ({ commit }, skillAction_payload) => {
    commit(types.SET_SKILL_ACTION, skillAction_payload);
};

export const setUnitUniqueEquip = ({ commit }, unitUniqueEquip_payload) => {
    commit(types.SET_UNIT_UNIQUE_EQUIP, unitUniqueEquip_payload);
};

export const setUniqueEquipmentData = ({ commit }, uniqueEquipmentData_payload) => {
    commit(types.SET_UNIQUE_EQUIPMENT_DATA, uniqueEquipmentData_payload);
};

export const setUniqueEquipmentEnhanceData = ({ commit }, uniqueEquipmentEnhanceData_payload) => {
    commit(types.SET_UNIQUE_EQUIPMENT_ENHANCE_DATA, uniqueEquipmentEnhanceData_payload);
};

export const setUniqueEquipmentEnhanceRate = ({ commit }, uniqueEquipmentEnhanceRate_payload) => {
    commit(types.SET_UNIQUE_EQUIPMENT_ENHANCE_RATE, uniqueEquipmentEnhanceRate_payload);
};

export const setUnitPromotionStatus = ({ commit }, unitPromotionStatus_payload) => {
    commit(types.SET_UNIT_PROMOTION_STATUS, unitPromotionStatus_payload);
};

export const setUnitRarity = ({ commit }, unitRarity_payload) => {
    commit(types.SET_UNIT_RARITY, unitRarity_payload);
};

export const setCharaStoryStatus = ({ commit }, charaStoryStatus_payload) => {
    commit(types.SET_CHARA_STORY_STATUS, charaStoryStatus_payload);
};

export const setUserStatus = ({ commit }, userStatus_payload) => {
    commit(types.SET_USER_STATUS, userStatus_payload);
};

export const setExEquipmentCategory = ({ commit }, exEquipmentCategory_payload) => {
    commit(types.SET_EX_EQUIPMENT_CATEGORY, exEquipmentCategory_payload);
};

export const setExEquipmentData = ({ commit }, exEquipmentData_payload) => {
    commit(types.SET_EX_EQUIPMENT_DATA, exEquipmentData_payload);
};

export const setExEquipmentEnhanceData = ({ commit }, exEquipmentEnhanceData_payload) => {
    commit(types.SET_EX_EQUIPMENTENHANCE_DATA, exEquipmentEnhanceData_payload);
};

export const setTalentQuestData = ({ commit }, talentQuestData_payload) => {
    commit(types.SET_TALENT_QUEST_DATA, talentQuestData_payload);
};

export const setTalentQuestAreaData = ({ commit }, talentQuestAreaData_payload) => {
    commit(types.SET_TALENT_QUEST_AREA_DATA, talentQuestAreaData_payload);
};

export const setUnitTalent = ({ commit }, unitTalent_payload) => {
    commit(types.SET_UNIT_TALENT, unitTalent_payload);
};
